import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import DistrictIcon from "../../Icons/DistrictIcon";

const DistrictListComponent = loadable(
  () => import("../../components/District/DistrictList")
);

const DistrictList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["districts"],
    navigateURL: null,
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.LOCATION}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <DistrictIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Districts</span>
      </div>
      <DistrictListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default DistrictList;
